<template>
  <div id="app">
    <GraphExplorer msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import GraphExplorer from './components/GraphExplorer.vue'

export default {
  name: 'App',
  components: {
    GraphExplorer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
